// extracted by mini-css-extract-plugin
export default {"block":"ate2iknZz9+mByMq3iC92g==","backgroundAnimation":"xEa51cHHLHPBJLos1r1Wfg=="};